import React from "react";
import FeedHistory from "../feedHistory/FeedHistory";
import FeedAssign from "./FeedAssign";
import CustomFields from "./CustomFields";

const ListFeedCard = ({ card, boardName }) => {
  return (
    <>
      {card && (
        <>
          {(card.response_object.event_type == "create_card" || card.response_object.event_type == "description_update") && (
            <FeedHistory history={card} boardName={boardName} />
          )}
          {card.response_object.event_type == "change_status" && (
            <FeedAssign history={card} boardName={boardName} />
          )}
          {card.response_object.event_type == "allocated_hours_update" && (
            <FeedHistory history={card} boardName={boardName} />
          )}
          {card.response_object.event_type == "change_board" && (
            <FeedAssign history={card} boardName={boardName} />
          )}
          {card.response_object.event_type == "card_assign" && (
            <FeedAssign history={card} boardName={boardName} />
          )}
          {card.response_object.event_type == "parent_task_relationship" && (
            <FeedHistory history={card} boardName={boardName} hideDetails={true} />
          )}
          {card.response_object.event_type == "priority_update" && (
            <FeedHistory history={card} boardName={boardName} />
          )}

          {card.response_object.event_type == "card_log_move_from_card" && (
            <FeedHistory history={card} boardName={boardName} />
          )}

          {(card.response_object.event_type == "attachment_added" ||
            card.response_object.event_type == "attachment_deleted" ||
            card.response_object.event_type == "label_added" ||
            card.response_object.event_type == "label_removed" ||
            card.response_object.event_type == "parent_task_relationship_removed" ||
            card.response_object.event_type == "collaborator_added" ||
            card.response_object.event_type == "collaborator_removed" ||
            card.response_object.event_type == "parent_card_update" ||
            card.response_object.event_type == "card_log_updated" ||
            card.response_object.event_type == "card_log_deleted" ||
            card.response_object.event_type == "card_log_move") && (
              <FeedHistory history={card} boardName={boardName} />
            )}

          {(
            card.response_object.event_type == "custom_field_update" &&
            <CustomFields history={card} boardName={boardName} />)}

          {(card.response_object.event_type == "due_date_update") && (
            <FeedHistory history={card} boardName={boardName} isDueDate={true} />
          )}
        </>
      )}
    </>
  );
};

export default ListFeedCard;
